export default "__VITE_ASSET__CsHzikBd__"